import React, { useState, useEffect } from "react";
import DynamicTable from "../../../../unicomponents/Tables/DynamicTable";
import useDeveloper from "../../../../hooks/useDeveloper";
import LoadingInside from "../../../../unicomponents/LoadingInside";

export default function ManageSchools() {
  const [selectedSchoolYears, setSelectedSchoolYears] = useState({});
  const [tableRows, setTableRows] = useState([]);

  const {
    schoolsManagementQuery: { isLoading, error, data: schoolsData },
  } = useDeveloper();

  useEffect(() => {
    if (schoolsData && schoolsData.length > 0) {
      // 각 학교의 기본 학년도를 최신년도로 설정
      const initialSchoolYears = {};
      const processedRows = schoolsData.map((school, index) => {
        const schoolYears = Object.keys(school.registrationStats || {}).sort(
          (a, b) => b - a
        );
        const defaultYear = schoolYears[0] || "";
        initialSchoolYears[school.id] = defaultYear;

        return {
          ...school,
          no: index + 1,
          schoolYear: defaultYear,
          enrollmentCount: school.registrationStats
            ? school.registrationStats[defaultYear] || 0
            : 0,
          teacherCount: school.userRoleStats?.teacher || 0,
          studentCount: school.userRoleStats?.student || 0,
          parentCount: school.userRoleStats?.parent || 0,
          totalUsers:
            (school.userRoleStats?.teacher || 0) +
            (school.userRoleStats?.student || 0) +
            (school.userRoleStats?.parent || 0) +
            (school.userRoleStats?.admin || 0),
        };
      });

      setSelectedSchoolYears(initialSchoolYears);
      setTableRows(processedRows);
    }
  }, [schoolsData]);

  const handleSchoolYearChange = (schoolId, newYear) => {
    setSelectedSchoolYears((prev) => ({
      ...prev,
      [schoolId]: newYear,
    }));

    setTableRows((prev) =>
      prev.map((row) => {
        if (row.id === schoolId) {
          return {
            ...row,
            schoolYear: newYear,
            enrollmentCount: row.registrationStats
              ? row.registrationStats[newYear] || 0
              : 0,
          };
        }
        return row;
      })
    );
  };

  const tableConfig = {
    style: { fontSize: "14px" },
    headers: [
      {
        label: "No.",
        style: { width: "60px", textAlign: "center" },
        sortField: "no",
      },
      {
        label: "학교아이디",
        style: { width: "150px", textAlign: "center" },
        sortField: "schoolid",
      },
      {
        label: "학교이름",
        style: { width: "200px", textAlign: "center" },
        sortField: "schoolname",
      },
      {
        label: "사용자그룹",
        style: { width: "120px", textAlign: "center" },
        sortField: "usergroup",
      },
      {
        label: "학년도",
        style: { width: "120px", textAlign: "center" },
      },
      {
        label: "재적인원",
        style: { width: "100px", textAlign: "center" },
        sortField: "enrollmentCount",
      },
      {
        label: "교직원 유저",
        style: { width: "120px", textAlign: "center" },
        sortField: "teacherCount",
      },
      {
        label: "학생 유저",
        style: { width: "120px", textAlign: "center" },
        sortField: "studentCount",
      },
      {
        label: "학부모 유저",
        style: { width: "120px", textAlign: "center" },
        sortField: "parentCount",
      },
      {
        label: "전체유저",
        style: { width: "100px", textAlign: "center" },
        sortField: "totalUsers",
      },
    ],
    columns: [
      {
        valueKey: "no",
        type: "display",
        cellStyle: { textAlign: "center" },
      },
      {
        valueKey: "schoolid",
        type: "display",
        cellStyle: { textAlign: "start" },
      },
      {
        valueKey: "schoolname",
        type: "display",
        cellStyle: { textAlign: "start" },
      },
      {
        valueKey: "usergroup",
        type: "display",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value) => value || "-",
      },
      {
        valueKey: "schoolYear",
        type: "display",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value, item) => {
          const schoolYears = Object.keys(item.registrationStats || {}).sort(
            (a, b) => b - a
          );
          return (
            <select
              className="form-select form-select-sm"
              value={selectedSchoolYears[item.id] || value}
              onChange={(e) => handleSchoolYearChange(item.id, e.target.value)}
              style={{ fontSize: "12px" }}
            >
              {schoolYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          );
        },
      },
      {
        valueKey: "enrollmentCount",
        type: "display",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value) => value?.toLocaleString() || "0",
      },
      {
        valueKey: "teacherCount",
        type: "display",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value) => value?.toLocaleString() || "0",
      },
      {
        valueKey: "studentCount",
        type: "display",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value) => value?.toLocaleString() || "0",
      },
      {
        valueKey: "parentCount",
        type: "display",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value) => value?.toLocaleString() || "0",
      },
      {
        valueKey: "totalUsers",
        type: "display",
        cellStyle: { textAlign: "center" },
        valueFormatter: (value) => value?.toLocaleString() || "0",
      },
    ],
    rows: tableRows,
  };

  if (isLoading) {
    return <LoadingInside />;
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        에러가 발생했습니다: {error.toString()}
      </div>
    );
  }

  return (
    <div className="ms-3 basicWidth">
      <div className="container-fluid">
        <div className="row mb-4 mt-2">
          <div className="col-12">
            <h3 className="fw-bold">학교세부정보</h3>
          </div>
        </div>

        <div style={{ width: "95vw", overflowX: "auto", maxWidth: "1536px" }}>
          <DynamicTable
            tableConfig={tableConfig}
            dataStructure="flat"
            tableStyle="cleanModern"
            pagination={true}
            pageSize={30}
            sortable={true}
            searchable={true}
            searchPlaceholder="검색..."
            searchFields={["schoolid", "schoolname", "schooladmin"]}
            exportable={true}
            exportFileName="학교세부정보"
            exportButtonLabel="Excel"
          />
        </div>
      </div>
    </div>
  );
}
